import styles from "./EdgeHint.module.css";
import type { DetonateHintVariantProps } from "./types";

/** Pattern C: the whole board edge pulses with a large faint call to action. */
export default function EdgeHint({ input }: DetonateHintVariantProps) {
  return (
    <div className={styles.root} role="status">
      <div className={styles.copy}>
        <strong>{input === "key" ? "SPACE" : "TAP"}</strong>
        <span>いま押すと爆発</span>
      </div>
    </div>
  );
}
